import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'' || sessionStorage.getItem('store')&&JSON.parse(sessionStorage.getItem('store')).token,
    id:'' || sessionStorage.getItem('store')&&JSON.parse(sessionStorage.getItem('store')).id, //当前登录用户的id
    name:'' || sessionStorage.getItem('store')&&JSON.parse(sessionStorage.getItem('store')).name,
    email:'' || sessionStorage.getItem('store')&&JSON.parse(sessionStorage.getItem('store')).email
  },
  mutations: {
    set_token(state, token) {
      state.token = token
      sessionStorage.setItem('token',token);
    },
    set_user(state,data){
      state.id = data?data['id']:''
      state.name=data?data['name']:''
      state.email=data?data['email']:''
      sessionStorage.setItem('id',data?data['id']:'');
      sessionStorage.setItem('name',data?data['name']:'');
      sessionStorage.setItem('email',data?data['email']:'');
    },
  },
  // actions:{
  //   setUser({commit},state){
  //     commit('set_id',state)
  //   }
  // }
})
